import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {POST_IEXAM_REQUEST_TYPES_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostIexamRequestType = ({onSuccess, onError}: Input = {}) => {
  const postIexamRequestType = async () => {
    await axiosClient.post(POST_IEXAM_REQUEST_TYPES_URL);
  };

  return useCustomMutation(postIexamRequestType, {
    onSuccess,
    onError,
  });
};
